import React from 'react';
import styled, { css } from 'styled-components';
import { Colors } from '../../../../../ui';
import { Check } from '../../../../../ui/Check';
import { Flexer } from '../../../../dashboard/elements/LayoutElements';

const Frame = styled.div`
    display: flex;
    gap: 1rem;
    align-items: center;
`;

const Step = styled.div<{ active?: boolean, focus?: boolean, clickable?: boolean }>`
    width: 2.5rem;
    height: 2.5rem;
    border-radius: 50%;
    border: .125rem solid ${p => p.active ? Colors.primary : Colors.textLightest};
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    cursor: ${p => p.clickable ? 'pointer' : 'default'};

    ${p => p.focus && css`
        &:after {
            content: '';
            position: absolute;
            width: 0.75rem;
            height: 0.75rem;
            border-radius: 50%;
            background: ${Colors.primary};
        }
    `}
`;
interface StepViewerProps {
    steps: number;
    activeIndex: number;
    onStep?: (stepIndex: number) => void;
}

export const SetupStepViewer: React.FC<StepViewerProps> = ({ steps, activeIndex, onStep }) => {
    const handleStepClick = (index: number) => {
        if (onStep && index < activeIndex) {
            onStep(index);
        }
    };

    return <Flexer flex="column" center>
        <Frame>
            {Array.from({ length: steps }, (_, index) => (
                <Step
                    key={index}
                    active={index <= activeIndex}
                    focus={index === activeIndex}
                    clickable={onStep && index < activeIndex}
                    onClick={() => handleStepClick(index)}
                >
                    {index < activeIndex && <>
                        <Check.Frame value={true} animate={false}>
                            <Check.On color={Colors.primary} />
                        </Check.Frame>
                    </>}
                </Step>
            ))}
        </Frame>
    </Flexer>;
};
